import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
import { grid } from '@finect/tabular-utils/grid';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

export const HeroText = styled.div`
  position: relative;
  max-width: ${grid(5)}px;
  ${fontSmoothing};
  color: #fff;

  h1 {
    margin-bottom: 24px;
    ${getFont(6, 'compact')};
    font-weight: 700;

    ${maxMediaQueries.tablet`
      ${getFont(5, 'compact')};
    `};
  }

  p {
    ${getFont(1)};
  }

  ${minMediaQueries.desktop`
  max-width: 590px;
  padding-left: ${grid(1)}px;
  `}

  ${maxMediaQueries.tablet`
  max-width: ${grid(4)}px;
  `}

  ${maxMediaQueries.phablet`
  max-width: ${grid(3)}px;

  h1 {
  ${getFont(4, 'compact')};
  }

  p {
  ${getFont(0)};
  }
  `}

  ${maxMediaQueries.phone`
  max-width: none;
  padding-right: 120px;
  `}

  @media (max-width: 360px) {
    padding-right: 0;

    p {
      padding-right: 120px;
    }
  }
`;
